module.exports = __webpack_public_path__ + "img/matcha03.2476d5fa.jpg";